import { createContext, useContext, useEffect, useMemo, useState } from "react";
import { api } from "../lib/api";

const PromoContext = createContext({ campaign: null, loaded: false });

// Fetches the single active campaign once (server decides which one is live).
// When there is NO active campaign, `campaign` stays null and the storefront
// renders completely normally — no banner, no popup, no placeholder.
export const PromoProvider = ({ children }) => {
  const [campaign, setCampaign] = useState(null);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    let alive = true;
    api.get("/active-campaign")
      .then((r) => { if (alive) setCampaign(r.data.campaign || null); })
      .catch(() => { if (alive) setCampaign(null); })
      .finally(() => { if (alive) setLoaded(true); });
    return () => { alive = false; };
  }, []);

  const value = useMemo(() => ({ campaign, loaded }), [campaign, loaded]);
  return <PromoContext.Provider value={value}>{children}</PromoContext.Provider>;
};

export const usePromo = () => useContext(PromoContext);
